// Small display formatters shared across pages.

// Format a date value (Date, ISO string, or timestamp) for display. Returns '' for
// missing/invalid input so callers never render "undefined", "Invalid Date", or a raw
// ISO string like "2026-05-04T00:00:00.000Z" (TTT-53).
export function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// A person's initials for an avatar without a picture (DS-6): 'Ana Cruz' -> 'AC', the first and
// last word for longer names, one word -> its first letter, no name -> '?'. Array.from splits by
// code point, so a letter outside the basic alphabet is never cut in half.
export function initials(name) {
  const words = String(name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = (word) => Array.from(word)[0].toUpperCase();
  return words.length === 1 ? first(words[0]) : first(words[0]) + first(words[words.length - 1]);
}

// Whole pesos, grouped. Shared so the earnings table and the chart tooltips can never render
// the same amount two different ways (TTT-17).
export const peso = (n) => `₱${Number(n || 0).toLocaleString('en-PH', { maximumFractionDigits: 0 })}`;
